import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: 'en-IN',
  fallbackLng: ['en-IN'],
  resources: {
    ['en-IN']: {
      translations: require('./source/en-IN/translations.json'),
    },
    ['bn-BD']: {
      translations: require('./source/bn-BD/translations.json'),
    },
    ['ur-PK']: {
      translations: require('./source/ur-PK/translations.json'),
    },
    ['ja-JP']: {
      translations: require('./source/ja-JP/translations.json'),
    },
    ['id-ID']: {
      translations: require('./source/id-ID/translations.json'),
    },
    ['pt-PT']: {
      translations: require('./source/pt-PT/translations.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});
i18n.languages = ['en-IN', 'bn-BD', 'ur-PK', 'ja-JP', 'id-ID', 'pt-PT'];

export default i18n;
